export const MEMBERSHIP_PLANS = [
  {
    id: 'daily',
    name: 'Pase Diario',
    price: '$4.990',
    perks: ['Uso de todas las máquinas', 'Planilla entrenamiento', '1 vez al día'],
  },
  {
    id: 'three-week',
    name: 'Plan 3 veces por semana',
    price: '$24.990',
    perks: ['Matrícula $5.000', '12 clases al mes', 'Uso de todas las máquinas', 'Planilla entrenamiento'],
  },
  {
    id: 'full',
    name: 'Plan Full',
    price: '$34.990',
    perks: ['Matrícula $5.000', '26 clases al mes', 'Uso de todas las máquinas', 'Planilla entrenamiento'],
  },
];

export const SESSION_TEMPLATES = {
  daily: [
    { day: 'Lunes', focus: 'Full body express', energy: 'Media', suggestion: 'Circuito guiado 45 min' },
    { day: 'Miércoles', focus: 'Fuerza tren superior', energy: 'Alta', suggestion: 'Press + Dominadas asistidas' },
    { day: 'Viernes', focus: 'Cardio + Core', energy: 'Media', suggestion: 'Bike + plancha' },
  ],
  'three-week': [
    { day: 'Lunes', focus: 'Pecho y tríceps', energy: 'Alta', suggestion: 'Superseries guiadas por coach' },
    { day: 'Miércoles', focus: 'Piernas y glúteos', energy: 'Muy alta', suggestion: 'Sentadillas profundas + Prensa' },
    { day: 'Viernes', focus: 'Espalda y bíceps', energy: 'Alta', suggestion: 'Remo barra + martillo' },
    { day: 'Sábado', focus: 'Funcional', energy: 'Media', suggestion: 'Clase grupal de circuito' },
  ],
  full: [
    { day: 'Lunes', focus: 'Fuerza total', energy: 'Alta', suggestion: 'Planilla fuerza intermedia' },
    { day: 'Martes', focus: 'Cardio HIIT', energy: 'Muy alta', suggestion: 'Bike + Battle rope' },
    { day: 'Miércoles', focus: 'Core y estabilidad', energy: 'Media', suggestion: 'Pilates Mat + Bosu' },
    { day: 'Jueves', focus: 'Hipertrofia pierna', energy: 'Alta', suggestion: 'Sentadillas búlgaras + desplantes' },
    { day: 'Viernes', focus: 'Box training', energy: 'Alta', suggestion: 'Sacos + salto de cuerda' },
    { day: 'Sábado', focus: 'Movilidad y descarga', energy: 'Baja', suggestion: 'Stretching guiado' },
  ],
};

export const WEEK_TRACK = [
  { day: 'Lun', date: 21, active: true, planFocus: 'Pecho + tríceps', goal: 'Planilla fuerza parte superior' },
  { day: 'Mar', date: 22, active: false, planFocus: 'Recuperación', goal: 'Descanso activo 20 min' },
  { day: 'Mié', date: 23, active: true, planFocus: 'Piernas + glúteos', goal: 'Clase funcional 60 min' },
  { day: 'Jue', date: 24, active: false, planFocus: 'Recuperación', goal: 'Mobilidad y foam roller' },
  { day: 'Vie', date: 25, active: true, planFocus: 'Espalda + bíceps', goal: 'Planilla tren superior B' },
  { day: 'Sáb', date: 26, active: false, planFocus: 'Funcional', goal: 'Bootcamp grupal' },
  { day: 'Dom', date: 27, active: false, planFocus: 'Descanso', goal: 'Recuperación total' },
];

export const HOME_STATS = [
  { id: 'attendance', icon: '✅', label: 'Asistencias del mes', value: 7, suffix: '/12', helper: 'Vas al día con tu plan' },
  { id: 'focus', icon: '🎯', label: 'Objetivo activo', value: 'Tonificar tren superior', helper: 'Hoy toca Pecho + Tríceps' },
  { id: 'medals', icon: '🏅', label: 'Medallas ganadas', value: 3, helper: 'Siguiente: Consistencia 4 semanas' },
];

export const DAILY_SESSIONS = [
  { id: 'mon', icon: '💪', title: 'Pecho + tríceps guiado', time: '07:30', focus: 'Fuerza', location: 'Sala Pesas A', status: 'Completado' },
  { id: 'wed', icon: '🦵', title: 'Piernas funcional', time: '19:00', focus: 'Funcional', location: 'Sala Studio', status: 'Pendiente' },
  { id: 'fri', icon: '🏋️', title: 'Espalda + bíceps', time: '08:00', focus: 'Fuerza', location: 'Sala Pesas B', status: 'Reservado' },
];

export const MASTER_CLASSES = [
  { id: 'assistant', title: 'Asistente personal Sportivos', badge: 'Plan activo', duration: 'Selecciona objetivo y te guiamos' },
  { id: 'gallery', title: 'Registra tu progreso', badge: 'Pronto', duration: 'Captura semanal con foto guía' },
  { id: 'offers', title: 'Promos y beneficios', badge: 'Nuevo', duration: 'Acad. descontada los viernes' },
];

export const PLAN_METRICS = [
  { id: 'status', label: 'Estado', value: 'Activo', tone: 'success' },
  { id: 'renewal', label: 'Renueva', value: '28 · Nov' },
  { id: 'sessions', label: 'Asistencias', value: '7/12' },
  { id: 'streak', label: 'Racha', value: '8 días' },
];

export const PLAN_SCHEDULE = [
  { id: 'mon-1', day: 'Lunes', session: 'Entrenamiento Funcional', time: '19:00', coach: 'Staff Sportivos' },
  { id: 'mon-2', day: 'Lunes', session: 'Baile Entretenido', time: '20:15', coach: 'Staff Sportivos' },
  { id: 'tue-1', day: 'Martes', session: 'Boxeo', time: '19:00', coach: 'Staff Sportivos' },
  { id: 'wed-1', day: 'Miércoles', session: 'Entrenamiento Funcional', time: '19:00', coach: 'Staff Sportivos' },
  { id: 'wed-2', day: 'Miércoles', session: 'Baile Entretenido', time: '20:15', coach: 'Staff Sportivos' },
  { id: 'thu-1', day: 'Jueves', session: 'Boxeo', time: '19:00', coach: 'Staff Sportivos' },
];

export const WORKOUT_TYPES = [
  { id: 'cardio', icon: '💓', label: 'Cardio' },
  { id: 'power', icon: '🏋️', label: 'Power', active: true },
  { id: 'endurance', icon: '🏃', label: 'Endurance' },
];

export const GAME_MEDALS = [
  { id: 'starter', title: 'Kick-off', description: 'Primera sesión completada', status: 'Listo' },
  { id: 'streak', title: 'Streak Lover', description: '7 días seguidos', status: 'En curso' },
  { id: 'mentor', title: 'Coach inside', description: 'Compartiste 3 tips', status: 'Listo' },
];

export const GAME_MEDAL_HISTORY = [
  {
    id: 'mentor-01',
    medal: 'Coach inside',
    achievedOn: '12 nov 2025',
    summary: 'Compartiste 3 tips en la comunidad',
    type: 'unlock',
  },
  {
    id: 'streak-02',
    medal: 'Streak Lover',
    achievedOn: '05 nov 2025',
    summary: 'Registraste 7 días consecutivos',
    type: 'progress',
  },
  {
    id: 'starter-01',
    medal: 'Kick-off',
    achievedOn: '23 oct 2025',
    summary: 'Completaste tu primera sesión guiada',
    type: 'unlock',
  },
  {
    id: 'power-week',
    medal: 'Power Week',
    achievedOn: '15 oct 2025',
    summary: 'Lograste 4/4 sesiones semanales',
    type: 'highlight',
  },
];

export const GAME_FOCUS = [
  { id: 'consistency', title: 'Consistencia 4 semanas', progress: 0.5, target: '2 / 4 semanas' },
  { id: 'speed', title: 'Sprint 3x', progress: 0.33, target: '1 / 3 sesiones' },
];

export const COMMUNITY_RANKING = [
  {
    id: 'camila',
    position: 1,
    name: 'Camila Reyes',
    assists: 18,
    medals: 12,
    avatar: 'https://images.unsplash.com/photo-1546483875-ad9014c88eba?auto=format&fit=crop&w=400&q=80',
  },
  {
    id: 'jose',
    position: 2,
    name: 'José Mora',
    assists: 15,
    medals: 9,
    avatar: 'https://images.unsplash.com/photo-1534438327276-14e5300c3a48?auto=format&fit=crop&w=400&q=80',
  },
  {
    id: 'javier',
    position: 3,
    name: 'Javier (tú)',
    assists: 14,
    medals: 7,
    avatar: 'https://images.unsplash.com/photo-1556817411-31ae72fa3ea0?auto=format&fit=crop&w=400&q=80',
  },
  {
    id: 'renata',
    position: 4,
    name: 'Renata',
    assists: 12,
    medals: 6,
    avatar: 'https://images.unsplash.com/photo-1561212044-0fe4c02a0979?auto=format&fit=crop&w=400&q=80',
  },
];

export const SOCIAL_MEDALS = [
  { id: 'winter', icon: '❄️', label: 'Desafío Invierno' },
  { id: 'power', icon: '⚡', label: 'Power Squad' },
  { id: 'mobility', icon: '🌀', label: 'Flow Lover' },
];

export const PROGRESS_SHOTS = [
  {
    id: 'week-8',
    label: 'Semana 8',
    accent: '#38bdf8',
    image: 'https://images.unsplash.com/photo-1556817411-31ae72fa3ea0?auto=format&fit=crop&w=500&q=80',
  },
  {
    id: 'week-12',
    label: 'Semana 12',
    accent: '#f472b6',
    image: 'https://images.unsplash.com/photo-1541534401786-2077eed87a75?auto=format&fit=crop&w=500&q=80',
  },
  {
    id: 'week-16',
    label: 'Semana 16',
    accent: '#22d3ee',
    image: 'https://images.unsplash.com/photo-1517836357463-d25dfeac3438?auto=format&fit=crop&w=500&q=80',
  },
];

export const NOTIFICATIONS = [
  {
    id: 'reminder-1',
    title: 'Funcional empieza en 30 min',
    description: 'Studio Power · 20:00',
    timeAgo: 'Hace 12 min',
    tone: 'urgent',
    unread: true,
    icon: '⏰',
    // fromAvatar kept for compatibility if needed, but moving to icons for consistency
    fromAvatar: null,
  },
  {
    id: 'coach-tip',
    title: 'Tip del Coach',
    description: 'Nuevo video: respira mejor durante el HIIT',
    timeAgo: 'Hace 1 h',
    icon: '💡',
    fromAvatar: null,
  },
  {
    id: 'community',
    title: 'Renata comentó tu progreso',
    description: '“Tu transformación está increíble 🔥”',
    timeAgo: 'Ayer',
    icon: '💬',
    fromAvatar: 'https://images.unsplash.com/photo-1518895949257-7621c3c786d4?auto=format&fit=crop&w=200&q=80',
  },
];
